import _jsx from '@babel/runtime/helpers/esm/jsx';
import { createContext, useMemo } from 'react';
import { Map } from 'immutable';
import { makeSelectCurrencyData } from '@dbh/countries-redux';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectReactRouterPageType } from '@dbh/routing-redux';
import _noop from 'lodash/noop';
import 'prop-types';
import 'react-immutable-proptypes';
import '@dbh/generic-types';
import { PAGE_TYPES } from '@dbh/admindev-constants';

const dbhReactRouterImmutablePropType=_noop;

const defaultCurrencyContextValue=Map({currencyData:Map({currencyCode:"EUR",currencySymbol:"\u20AC",displayVATInfo:!1}),displayFloatingPointDigits:!0});const pageTypesWithHiddenFloatingPointDigits=Object.freeze([PAGE_TYPES.HdpPage,PAGE_TYPES.ShoppingCartPage,PAGE_TYPES.PdpPage,// Pages with `SearchResultsPage` template:
PAGE_TYPES.SearchResultsPage,PAGE_TYPES.CategoryCityPage,PAGE_TYPES.PoiPage,PAGE_TYPES.FlagContentPage,PAGE_TYPES.UserReservationsPage,PAGE_TYPES.ContentPage]);

const CurrencyContext=/*#__PURE__*/createContext(defaultCurrencyContextValue),{Provider}=CurrencyContext,CurrencyContextProvider=a=>{let{displayFloatingPointDigits:b,children:c}=a;const d=useMakeSelect(makeSelectCurrencyData),e=useMakeSelect(makeSelectReactRouterPageType),f=useMemo(()=>{const a="boolean"==typeof b?b:!pageTypesWithHiddenFloatingPointDigits.includes(e);return Map({currencyData:d,displayFloatingPointDigits:a})},[d,e,b]);return/*#__PURE__*/_jsx(Provider,{value:f},void 0,c)};CurrencyContextProvider.displayName="CurrencyContextProvider";

export { CurrencyContextProvider as CurrencyProvider, dbhReactRouterImmutablePropType, CurrencyContext as default, defaultCurrencyContextValue };
